module.exports = __webpack_public_path__ + "static/media/top_banner_pc_01.37f7210d.webp";